import BigNumber from 'bignumber.js';

export const getSwapPathDisplay = (path: string[]) => {
  const amount = path[1];

  if (!isNaN(Number(amount))) {
    path[1] = `${BigNumber(amount).dividedBy(10000).toString()}%`;
  }

  return path.join(' -> ');
};
